import { render, staticRenderFns } from "./ChinaMedicineList.vue?vue&type=template&id=5ece2a18&scoped=true"
import script from "./ChinaMedicineList.vue?vue&type=script&lang=js"
export * from "./ChinaMedicineList.vue?vue&type=script&lang=js"
import style0 from "./ChinaMedicineList.vue?vue&type=style&index=0&id=5ece2a18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece2a18",
  null
  
)

export default component.exports